import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RichTextControl } from '../../../form-models/form-control-base';

@Component({
  selector: 'hb-dynamic-rich-text',
  templateUrl: './dynamic-rich-text.component.html',
  styleUrls: ['./dynamic-rich-text.component.scss'],
})
export class DynamicRichTextComponent {
  @Input() control: RichTextControl;
  @Input() formGroup: FormGroup;
  @Input() isEditable: boolean = true;

  @Output() onOverrideValue = new EventEmitter();

  constructor() {}

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
